import '../../App.css'
import { useState, useEffect } from 'react';
import { Table } from 'antd';
import axios from 'axios';
import Appconfig from '../../config/config'
import { useSelector } from 'react-redux';
import AccountSidebar from 'components/AccountSidebar';

function ActivityLog() {
    const userInfo = useSelector((state) => state?.userInfo?.userdata); // get login user details

    const [formData, setFormData] = useState({
        "user_id": userInfo && userInfo?._id,
        "user_type": userInfo && userInfo?.user_type,
    })

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        activeLog();
    }, [])

    const activeLog = async () => {
        setLoading(true);
        var dataPayload = JSON.stringify(formData);

        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}reports/usersOnline`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: dataPayload
        };

        axios(config)
            .then(function (response) {
                try {
                    setData(response.data.resultData);
                    setLoading(false);
                } catch (e) {
                    setLoading(false);
                }
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    }

    let locale = {
        emptyText: 'No data!',
    };

    const columns = [
        {
            title: 'Login Date & Time',
            dataIndex: 'createdAt',
            width: 200,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                    {new Date(record?.createdAt).toLocaleString()}
                </span>
            )
        },
        {
            title: 'Login Status',
            dataIndex: 'status',
            width: 150,
            render: (_, record) => (
                <span className={`font-extrabold text-[0.813rem] ${record?.status == "Open" ? 'text-[#228b22]' : 'text-[#dc3545]'}`}>
                    {record?.status == "Open" ? 'User Successfully Logged' : 'Login Failed'}
                </span>
            ),
        },
        {
            title: 'IP Address',
            dataIndex: 'ip_address',
            width: 150,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{record?.ip_address}</span>
            ),
        },
        {
            title: 'ISP',
            dataIndex: 'isp',
            width: 150,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{record?.all_info[0]?.isp || '-'}</span>
            ),
        },
        {
            title: 'City/State/Country',
            dataIndex: 'address',
            width: 250,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                    {record?.all_info[0] 
                        ? `${record?.all_info[0]?.city} / ${record?.all_info[0]?.regionName} / ${record?.all_info[0]?.country}`
                        : '-'
                    }
                </span>
            ),
        },
    ];

    // Helper Component for Section Headers (Matches MyProfile)
    const SectionHeader = ({ title }) => (
        <div className='px-3 py-[2px] bg-[#7e97a7] text-white font-bold text-sm'>
            {title}
        </div>
    );

    return (
        <div className="bg-[#eeeeee] min-h-screen font-sans pt-[60px] pb-[80px] lg:pt-0 lg:pb-0 overflow-x-hidden">
            <div className="w-full max-w-[1300px] mx-auto px-2 lg:px-4 flex flex-col lg:flex-row gap-4 items-start">
                
                {/* Left Sidebar */}
                <div className="hidden lg:block lg:w-[220px] xl:w-[240px] flex-shrink-0">
                    <AccountSidebar />
                </div>

                {/* Main Content */}
                <div className="flex-1 w-full min-w-0">
                    <h2 className="text-sm font-bold mb-1 mt-1 text-gray-800">Activity Log</h2>

                    {/* Table Section */}
                    <div className="bg-white border border-gray-300 rounded shadow-sm">
                        <SectionHeader title="Activity Log" />

                        <div className='p-4 bg-white'>
                            <Table
                                bordered
                                locale={locale}
                                columns={columns}
                                className='activity-log profit-loss'
                                dataSource={data}
                                loading={loading}
                                rowKey={(record) => record._id || Math.random()} 
                                scroll={{ x: true }} // Enables horizontal scroll on mobile
                                pagination={{ pageSize: 10 }}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ActivityLog;